import { render, staticRenderFns } from "./reStation.vue?vue&type=template&id=5bdb9b3e&scoped=true&"
import script from "./reStation.vue?vue&type=script&lang=js&"
export * from "./reStation.vue?vue&type=script&lang=js&"
import style0 from "./reStation.vue?vue&type=style&index=0&id=5bdb9b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb9b3e",
  null
  
)

export default component.exports